import { render, staticRenderFns } from "./detail-history.vue?vue&type=template&id=10ac4630"
import script from "./detail-history.vue?vue&type=script&lang=ts"
export * from "./detail-history.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports